/**
 * Followed the example in https://christianliebel.com/2016/05/angular-2-a-simple-click-outside-directive/
 */
import { Directive, Output, ElementRef, HostListener, EventEmitter, HostBinding } from '@angular/core';

@Directive({
  selector: '[pioneerFocusOutside]'
})
export class FocusOutsideDirective {

  @Output()
  pioneerFocusOutside = new EventEmitter();

  @HostBinding('tabindex') tabindex = -1;

  constructor(private _elementRef: ElementRef) { }

  @HostListener('document:focusin', ['$event.target'])
  onFocusIn(targetElement) {
    const focusedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!focusedInside) {
      this.pioneerFocusOutside.emit();
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/directives/focus-outside.directive.ts